if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** Compare Carousel
         *
         * shift products left and right for comparison
         */
        ZZ.CompareCarousel = function(container) {
            var base = this;

            base.container = container;
            base.table =
                base.container.prop("tagName").toUpperCase() === "TABLE"
                    ? base.container
                    : base.container.find("table:first");

            base.init();
            base.assignGlobalListeners();
            base.assignGlobalNavListeners();
        };

        ZZ.CompareCarousel.prototype = {
            _defaultConfig: {
                featuredClassname: "featured",
                widthThresholdSmall: 500,
                widthThresholdMedium: 700
            },

            init: function() {
                var base = this;

                base.productColumnWidth = base.table.width();

                base.leftBtn = base.container.find(".table-left");
                base.rightBtn = base.container.find(".table-right");

                base.curStep = 0;
                base.minStep = -1;
                base.maxStep = base.table.find("tr:first th").length - 1;

                base.config = $.extend(
                    {},
                    base._defaultConfig,
                    base.container.data()
                );

                base.table.css({ position: "relative" });
                base.table.parent().css({ overflow: "hidden" });

                base.setDimensions();
                base.checkStep();
                base.assignListeners();

                // Center on the selected option, or - if there is no option selected - center on featured item
                var featuredIndex = base.getFeaturedItemIndex(),
                    chosenIndex = base.getChosenItemIndex();
                base.centerItem(chosenIndex > 0 ? chosenIndex : featuredIndex);
            },

            assignGlobalListeners: function() {
                var base = this,
                    windowHeight = $(window).height(),
                    windowWidth = $(window).width(),
                    currentHeight = $(window).height(),
                    currentWidth = $(window).width();

                // recalculate dimensions of columns on window resize
                $(window).on("resize", function() {
                    currentHeight = $(window).height();
                    currentWidth = $(window).width();

                    // check if window size is really changed (necessary due to resize fire event bug in IE8)
                    if (
                        currentHeight != windowHeight ||
                        currentWidth != windowWidth
                    ) {
                        base.setDimensions();

                        windowHeight = currentHeight;
                        windowWidth = currentWidth;
                    }
                });

                // left and right keyboard buttons
                $(window).on("keydown", function(e) {
                    if (
                        base.table.is(":visible") &&
                        base.isScrolledIntoView(base.table)
                    ) {
                        var leftArrowKeyCode = 37,
                            rightArrowKeyCode = 39;

                        if (e.which === leftArrowKeyCode) {
                            if (!base.leftBtn.hasClass("disabled")) {
                                base.left();
                            }
                        }
                        if (e.which === rightArrowKeyCode) {
                            if (!base.rightBtn.hasClass("disabled")) {
                                base.right();
                            }
                        }
                    }
                });
            },

            assignGlobalNavListeners: function() {
                var base = this;

                // button clicks
                base.leftBtn.on("click", function(e) {
                    e.preventDefault();
                    if (!base.leftBtn.hasClass("disabled")) {
                        base.left();
                    }
                });

                base.rightBtn.on("click", function(e) {
                    e.preventDefault();
                    if (!base.rightBtn.hasClass("disabled")) {
                        base.right();
                    }
                });

                // swipe event
                var startCoordinate = { x: 0, y: 0 },
                    delta = { x: 0, y: 0 },
                    threshold = 15;

                base.container.on("touchstart", function(e) {
                    var touch =
                        e.originalEvent.touches[0] ||
                        e.originalEvent.changedTouches[0];
                    startCoordinate.x = touch.pageX;
                    startCoordinate.y = touch.pageY;
                });

                base.container.on("touchend touchcancel", function(e) {
                    var touch =
                        e.originalEvent.touches[0] ||
                        e.originalEvent.changedTouches[0];

                    delta.x = startCoordinate.x - touch.pageX;
                    delta.y = startCoordinate.y - touch.pageY;

                    if (
                        Math.abs(delta.x) > threshold && // movement should be bigger than threshold
                        Math.abs(delta.x) > Math.abs(delta.y)
                    ) {
                        // movement should be more horizontal than vertical
                        if (delta.x < 0) {
                            // swipe to left
                            if (!base.leftBtn.hasClass("disabled")) {
                                base.left();
                            }
                        } else {
                            // swipe to right
                            if (!base.rightBtn.hasClass("disabled")) {
                                base.right();
                            }
                        }
                    }
                });
            },

            assignListeners: function() {
                var base = this;

                // choose insurance in compare carousel
                base.table
                    .find("[data-compare-choose]")
                    .on("click", function(e) {
                        e.preventDefault();
                        base.select($(this));
                    });

                // av select change
                var selectId = base.escapeBrackets(
                        base.table
                            .find("[data-compare-choose]")
                            .attr("data-compare-choose")
                            .split("=")[0]
                    ),
                    select = $(selectId);

                select.on("change.CompareCarousel ZZ_change_av", function(e) {
                    var selectedOption = $(this).find(":selected");
                    if (selectedOption.length === 1) {
                        var curSelectId = base.escapeBrackets(
                            $(this).attr("id")
                        );
                        var chosen = $(
                            '[data-compare-choose="#' +
                                curSelectId +
                                "=" +
                                selectedOption.val() +
                                '"]'
                        );
                        if (chosen.length > 0) {
                            base.selectItem(
                                chosen,
                                base.getVisibleSelectedOptionIndex(select)
                            );
                        } else {
                            base.selectItem(null);
                        }
                    }
                });

                // trigger on init in case of a pre-chosen option
                select.trigger("change.CompareCarousel");
            },

            getVisibleSelectedOptionIndex: function(selectElement) {
                var base = this;

                var $avSelectOptionsParent = $(selectElement).find(
                    'option:not([style*="display: none"])'
                );
                var indexCountSelectOptions = -1;
                $avSelectOptionsParent.each(function() {
                    ++indexCountSelectOptions;

                    if ($(this).is(":selected")) {
                        return false;
                    }
                });

                return indexCountSelectOptions;
            },

            left: function() {
                var base = this,
                    newLeft = base.productColumnWidth * ++base.curStep;
                if (base.maxStep > 1) {
                    base.table.css({ left: newLeft });
                    return base.checkStep();
                }
            },

            right: function() {
                var base = this,
                    newLeft = base.productColumnWidth * --base.curStep;
                if (base.maxStep > 1) {
                    base.table.css({ left: newLeft });
                    return base.checkStep();
                }
            },

            // @btn expects attribute [data-compare-choose=#id-of-select=value]
            select: function(btn) {
                var base = this,
                    action = btn.attr("data-compare-choose").split("=");

                // escape any brackets (for jquery select)
                action[0] = base.escapeBrackets(action[0]);

                var select = $(action[0]),
                    value = action[1],
                    selectedIndex;

                $("[data-hide-with-product]").each(function() {
                    $(this).css("display", "block");
                });

                $("[data-hide-with-product=" + value + "]").each(function() {
                    $(this).css("display", "none");
                })

                // select option
                select.find("option").prop("selected", false);
                select.find("[value=" + value + "]").prop("selected", true);
                select.trigger("change");
                select.get(0).dispatchEvent(new Event("change"));

                selectedIndex = base.getVisibleSelectedOptionIndex(select);

                base.selectItem(btn, selectedIndex);
            },

            // @selectedButton  - button of selected product
            // @selectedIndex   - index of selected product
            selectItem: function(selectedButton, selectedIndex) {
                var base = this,
                    previousChosenBtn,
                    btnTxt;

                // change button previously chosen product
                previousChosenBtn = base.table.find(
                    ".chosen[data-compare-choose]"
                );
                previousChosenBtn.removeClass("chosen");
                btnTxt = previousChosenBtn.attr("data-compare-alt-text");
                if (typeof btnTxt !== "undefined") {
                    previousChosenBtn.attr(
                        "data-compare-alt-text",
                        previousChosenBtn.text()
                    );
                    previousChosenBtn.text(btnTxt);
                }

                // if chosen item is not available in carousel
                if (selectedButton === null) {
                    base.table
                        .find("td.selected, th.selected")
                        .removeClass("selected");
                    return;
                }

                // change button newly chosen product
                selectedButton.addClass("chosen");
                btnTxt = selectedButton.attr("data-compare-alt-text");
                if (typeof btnTxt !== "undefined") {
                    selectedButton.attr(
                        "data-compare-alt-text",
                        selectedButton.text()
                    );
                    selectedButton.text(btnTxt);
                }

                // set state of product in table to selected
                base.table
                    .find("td.selected, th.selected")
                    .removeClass("selected");
                base.table
                    .find(
                        "td:nth-child(" +
                            selectedIndex +
                            "), th:nth-child(" +
                            selectedIndex +
                            ")"
                    )
                    .addClass("selected");

                base.centerItem(selectedIndex);
            },

            // @index is number of product item in the carousel (starting by 1)
            centerItem: function(index) {
                var base = this,
                    goal = -index + (1 - base.minStep),
                    go = true;

                while (base.curStep !== goal && go) {
                    if (base.curStep < goal) {
                        go = base.left();
                    } else {
                        go = base.right();
                    }
                }
            },

            // returns false if begin or end is reached
            checkStep: function() {
                var base = this;

                base.leftBtn.removeClass("disabled");
                base.rightBtn.removeClass("disabled");

                if (base.curStep >= -base.minStep) {
                    base.leftBtn.addClass("disabled");
                    return false;
                } else if (base.curStep <= -base.maxStep) {
                    base.rightBtn.addClass("disabled");
                    return false;
                } else if (base.maxStep <= 1) {
                    base.leftBtn.addClass("disabled");
                    base.rightBtn.addClass("disabled");
                    return true;
                } else {
                    return true;
                }
            },

            getFeaturedItemIndex: function() {
                var base = this,
                    columns = base.table.find("th"),
                    columnsLength = columns.length,
                    i;

                for (i = 0; i < columnsLength; i++) {
                    if ($(columns[i]).hasClass(base.config.featuredClassname)) {
                        return i + 1;
                    }
                }
                return 0;
            },

            getChosenItemIndex: function() {
                var base = this,
                    btns = base.table.find("[data-compare-choose]"),
                    index = 0;

                btns.each(function(i) {
                    if ($(this).hasClass("chosen")) {
                        index = ++i;
                    }
                });

                return index;
            },

            // set correct width of product items
            setDimensions: function() {
                var base = this,
                    newLeft = base.productColumnWidth * base.curStep,
                    tableWidth = base.table
                        .parent()
                        .width() /* take parent (wrapper) of table as reference due to calculation error in IE */,
                    widthThresholdSmall = base.config.widthThresholdSmall,
                    widthThresholdMedium = base.config.widthThresholdMedium,
                    productWidth,
                    columns = base.table.find("td, th"),
                    padding = columns.outerWidth() - columns.width();

                // Correct position to new column width
                //  (Not animated since this is a screen resize)
                base.table.css({ left: newLeft });

                // get correct width of table if container is hidden
                if (base.container.is(":hidden")) {
                    base.container.show();
                    tableWidth = base.container.width();
                    base.container.hide();
                }

                // show 1, 2 or 3 products in view, depending on available width
                if (tableWidth <= widthThresholdSmall) {
                    productWidth = tableWidth;
                    base.minStep = 0;
                    base.maxStep += 1;
                } else if (tableWidth <= widthThresholdMedium) {
                    productWidth = tableWidth / 2;
                    base.minStep = 0;
                    base.maxStep += 1;
                } else {
                    productWidth = tableWidth / 3;
                }
                base.productColumnWidth = productWidth;

                productWidth = productWidth - padding;
                columns.css({
                    "min-width": productWidth + "px",
                    width: productWidth + "px"
                });
            },

            // escape any brackets within @value (for jquery select)
            escapeBrackets: function(value) {
                var result = value.replace("[", "\\[");
                result = result.replace("]", "\\]");

                return result;
            },

            // check if @elem is in current view
            isScrolledIntoView: function(elem) {
                var tolerance = 70,
                    viewTop = $(window).scrollTop(),
                    elemTop = elem.offset().top;

                return elemTop >= viewTop - tolerance;
            }
        };
    })(jQuery);
}
